import React, { useState, useEffect } from 'react'
import AdminBlogAddUpdateModal from '../AdminBlogAddUpdateModal';
import { Tooltip } from '@mui/material';
import AdminBlogViewModal from '../AdminBlogViewModal';
import dayjs from 'dayjs';
import NoResultFoundModel from '../../components/NoResultFoundModal';
import StatusChangeModal from '../../../StatusChangeModal';
import Android12Switch from '../../../Android12Switch';
import SuccessPopupModal from '../../components/SuccessPopupModal';
import { useAuth } from '../../../Context/AuthContext';
import ProjectAddUpdateModal from './ProjectAddUpdateModal';
import { projectCatList, ChangeStateStatus } from '../../../Services/Project Category/ProjectCategoryApi';
import { Link } from 'react-router-dom';
import { isVideoSource } from '../../../mediaHelpers';
const ProjectList = () => {
  const [stateChangeStatus, setStateChangeStatus] = useState('');
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [isAddUpdateActionDone, setIsAddUpdateActionDone] = useState(false);
  const [showBlogViewModal, setShowBlogViewModal] = useState(false);
  const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);

  const [totalRecords, setTotalRecords] = useState(-1);
  const [modelAction, setModelAction] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [showSuccessModal, setShowSuccessModal] = useState();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [totalCount, setTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(30);
  const [errorMessage, setErrorMessage] = useState(false)
  const [blogListData, setBlogListData] = useState([])

  const { setLoader, user } = useAuth()
  const [modelRequestData, setModelRequestData] = useState({
    customerID: null,
    customerKeyID: null,
    companyID: null,
    talukaID: null,
    talukaName: null,
    name: null,
    mobileNo: null,
    address: null,
    adharNumber: null,
    adharFrontImageURL: null,
    adharBackImageURL: null,
    status: null,
    createdOnDate: null
  });




  useEffect(() => {
    GetMasterBlogListData(1, null)
  }, [])

  useEffect(() => {
    // debugger
    if (isAddUpdateActionDone) {
      GetMasterBlogListData(1, null)
    }


    setIsAddUpdateActionDone(false)
  }, [isAddUpdateActionDone])

  const GetMasterBlogListData = async (pageNumber, searchKeywordValue) => {
    setLoader(true);
    try {
      const data = await projectCatList({
        pageSize,
        pageNo: pageNumber - 1, // Page numbers are typically 0-based in API calls
        searchKeyword: searchKeywordValue === undefined ? searchKeyword : searchKeywordValue,

        userKeyID: user.userKeyID
      });

      if (data) {
        if (data?.data?.statusCode === 200) {
          setLoader(false);
          if (data?.data?.responseData?.data) {
            const MasterStateListData = data.data.responseData.data;
            const totalItems = data.data?.totalCount; // const totalItems = 44;
            setTotalCount(totalItems);
            const totalPages = Math.ceil(totalItems / pageSize);
            setTotalPage(totalPages);
            setTotalRecords(MasterStateListData.length);
            setBlogListData(MasterStateListData);
          }
        } else {
          setErrorMessage(data?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const addMasterStateBtnClick = () => {
    setModelRequestData({
      ...modelRequestData,
      adminID: null,
      machineID: null,
      Action: null
    });

    setShowCustomerModal(true)
  }
  const blogEditBtnClicked = (row) => {

    setModelRequestData({
      ...modelRequestData,
      ProjectCatKeyID: row.ProjectCatKeyID,
      Action: "Update"
    });

    setShowCustomerModal(true)
  }

  const viewBlogBtnClick = (row) => {
    setModelRequestData({
      ...modelRequestData,
      BlogKeyID: row.BlogKeyID,
      Action: "Update"
    });
    setShowBlogViewModal(true)
  }

  const handleSearch = (e) => {
    let searchKeywordValue = e.target.value;
    const trimmedValue = searchKeywordValue.replace(/^\s+/g, '');
    const capitalizedValue = trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1).toLowerCase();
    if (searchKeywordValue.length === 1 && searchKeywordValue.startsWith(' ')) {
      searchKeywordValue = searchKeywordValue.trimStart();
      return;
    }
    setSearchKeyword(capitalizedValue);
    GetMasterBlogListData(1, capitalizedValue);
  };
  const closeAllModal = () => {
    setShowSuccessModal(false)
  }

  const handleStatusChange = (row) => {
    setStateChangeStatus(row); // You can set only relevant data if needed
    setShowStatusChangeModal(true);
  };

  const confirmStatusChange = async (row) => {
    setLoader(true)
    try {
      const { ProjectCatKeyID } = row; // Destructure to access only what's needed
      const response = await ChangeStateStatus(ProjectCatKeyID);

      if (response && response.data.statusCode === 200) {
        setShowStatusChangeModal(false);
        setLoader(false)
        setStateChangeStatus(null);
        GetMasterBlogListData(1, null)
        setShowSuccessModal(true);
        setModelAction('Project category status changed successfully.');
      } else {
        console.error(response?.data?.errorMessage);
        setShowSuccessModal(true);
        setLoader(false)
        setModelAction('Failed to change employee status.');
      }
    } catch (error) {
      console.error('Error changing employee status:', error);
      setShowSuccessModal(true);
      setLoader(false)
      setModelAction('An error occurred while changing the employee status.');
    }
  };

  return (
    <>

      <div className="card w-full max-w-[60vh] mx-auto h-auto">
        <div className="card-body p-2 bg-white shadow-md rounded-lg">
          {/* Top controls */}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h5 className="m-0 text-dark">Project Category</h5>
            <button
              onClick={() => addMasterStateBtnClick()}
              className="btn btn-primary btn-sm d-inline d-sm-none"
            >
              <i className="fa-solid fa-plus" style={{ fontSize: "11px" }}></i>
              <span className="d-inline d-sm-none">  Add</span>
            </button>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <input
              type="text"
              className="form-control "
              placeholder="Search Project Category"
              style={{ maxWidth: "350px" }}
              value={searchKeyword}
              onChange={(e) => {
                handleSearch(e);
              }}
            />
            {/* <Tooltip title="Add State"> */}



            <button class="rts-btn btn-primary  btn-sm d-none d-sm-inline" style={{
              backgroundColor: '#FF4D1C', // same as the orange color
              color: '#fff',
              padding: '8px 8px',
              fontSize: '14px',
              lineHeight: '1.2',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '3px'
            }}>
              <i className="fa-solid fa-plus" style={{ fontSize: "11px" }}></i>
              <span onClick={() => addMasterStateBtnClick()} className="d-none d-sm-inline"> Add Project Category</span>
            </button>

            {/* <button  onClick={() => addMasterStateBtnClick()} type="submit" class="rts-btn btn-primary">Add Blog</button> */}


          </div>

          {/* Table */}
          <div className="table-responsive" style={{ maxHeight: '75vh', overflowY: 'auto', position: 'relative' }}>
            <table className="table table-bordered table-striped">
              <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                <tr className='text-nowrap'>
                  <th className="text-center">Sr No</th>
                  <th className="text-center">Project Category</th>
                  {/* <th className="text-center">Image</th> */}
                  <th className="text-center">Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {blogListData?.map((row, idx) => (
                  <tr key={idx}>
                    {/* <td className="text-center">{(currentPage - 1) * pageSize + idx + 1}</td> */}
                    <td className="text-center">{idx + 1}</td>
                    <td className="text-center">{row.ProjectCatName}</td>
                    {/* <td className="text-center">

                  {isVideoSource(row.ProjectCatImage) ? (
                    <video
                      src={row.ProjectCatImage}
                      width={50}
                      height={60}
                      muted
                      playsInline
                      preload="metadata"
                    />
                  ) : (
                    <img src={row.ProjectCatImage} width={50} height={60} alt={row.ProjectCatName} />
                  )}

                  </td> */}


                    <td className="text-center">
                      <Tooltip
                        title={
                          row.status === "InActivate" ? "Click to Activate" : "Click to Deactivate"
                        }
                      >
                        <Link
                          onClick={() => handleStatusChange(row)}
                          style={{
                            color: row.status === "InActivate" ? "#dc3545" : "#198754",
                            fontWeight: 600,
                            textDecoration: "none",
                          }}
                        >
                          {row.status === "InActivate" ? "Inactive" : "Active"}
                        </Link>
                      </Tooltip>
                    </td>

                    <td className="text-center actionColSticky" style={{ zIndex: 4 }}>
                      <div className="d-inline-flex justify-content-center align-items-center " style={{ gap: '10px' }}>
                        <Tooltip title="Update Project Category">
                          <button
                            style={{
                              padding: '8px',
                              fontSize: '12px',
                              height: '30px',
                              color: 'white',
                              width: '30px',

                            }}
                            onClick={() => blogEditBtnClicked(row)}
                            className=" rts-btn btn-primary"
                          >
                            <i className="fa-regular fa-pen-to-square"></i>
                          </button>
                        </Tooltip>


                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
            {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}
          </div>
          <div className="d-flex justify-content-end ">
            {/* {totalCount > pageSize && (
            <PaginationComponent totalPages={totalPage} currentPage={currentPage} onPageChange={handlePageChange} />
          )} */}
          </div>
        </div>
      </div>

      {/* {openMasterStateModal && (
      <AddUpdateMasterStateModal
        show={openMasterStateModal}
        onHide={() => setOpenMasterStateModal(false)}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
        setIsAddUpdateActionDone={setIsAddUpdateActionDone}
      />
    )}
      

    <StatusChangeModal
      open={showStatusChangeModal}
      onClose={() => setShowStatusChangeModal(false)}
      onConfirm={() => confirmStatusChange(stateChangeStatus, user)} // Pass the required arguments
    />

    {showSuccessModal && (
      <SuccessPopupModal
        show={showSuccessModal}
        onHide={() => closeAllModal()}
        setShowSuccessModal={setShowSuccessModal}
        modelAction={modelAction}
      />
    )} */}

      <StatusChangeModal
        open={showStatusChangeModal}
        onClose={() => setShowStatusChangeModal(false)}
        onConfirm={() => confirmStatusChange(stateChangeStatus, user)} // Pass the required arguments
      />

      {showCustomerModal && (
        <ProjectAddUpdateModal
          show={showCustomerModal}
          onHide={() => setShowCustomerModal(false)}
          modelRequestData={modelRequestData}
          setModelRequestData={setModelRequestData}
          setIsAddUpdateActionDone={setIsAddUpdateActionDone}
        />)}
      {showBlogViewModal && (
        <ProjectAddUpdateModal
          show={showBlogViewModal}
          onHide={() => setShowBlogViewModal(false)}
          modelRequestData={modelRequestData}
          setModelRequestData={setModelRequestData}
          setIsAddUpdateActionDone={setIsAddUpdateActionDone}
        />)}
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  )
}

export default ProjectList

